import { render, staticRenderFns } from "./ViewFile.vue?vue&type=template&id=63c90bf5&scoped=true"
import script from "./ViewFile.vue?vue&type=script&lang=js"
export * from "./ViewFile.vue?vue&type=script&lang=js"
import style0 from "./ViewFile.vue?vue&type=style&index=0&id=63c90bf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c90bf5",
  null
  
)

export default component.exports